'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Personal = require('./Personal');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Personal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Personal/index.js
// module id = 1254
// module chunks = 1